bam-job-search {
  .bam-job-search-background {
    position: relative;
    @include mobile() {
      padding: 16px 0 16px 0;
    }
    @include tablet() {
      padding: 56px 0 56px 0;
    }
    @include desktop() {
      padding: 64px 0 64px 0;
    }


    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: calc((100vw - 100%) / 2 * -1);
      right: calc((100vw - 100%) / 2 * -1);
      bottom: 0;
      background-color: var(--bal-color-purple);
    }

    &.is-green::before {
      background-color: var(--bal-color-green);
    }

    &.is-purple::before {
      background-color: var(--bal-color-purple);
    }

    &.is-red::before {
      background-color: var(--bal-color-red);
    }

    &.is-yellow::before {
      background-color: var(--bal-color-yellow);
    }


    bal-card {
      position: relative;
    }
  }

  .is-widget-title {
    position: relative;
    z-index: 1;
  }

  .bam-job-search-controls {
    display: flex;
    flex-direction: column;
    row-gap: 0.25rem;
    column-gap: 1rem;
    padding-inline: 1rem;

    bal-field-control {
      padding-bottom: 0;
    }

    &__submit-btn button {
      width: 100%;

      @include tablet() {
        width: 248px !important;
      }
    }

    @include tablet() {
      flex-direction: row;
      align-items: center;

      bal-field {
        margin-bottom: 0 !important;
      }
    };
  }

  bam-job-search-result-counter {
    display: block;
    @include mobile() {
      margin-top: 24px;
      margin-bottom: 40px;
    }
    @include tablet() {
      margin-top: 24px;
      margin-bottom: 40px;
    }
    @include desktop() {
      margin-top: 8px;
      margin-bottom: 64px;
    }
  }

  .bam-job-search-item {
    bal-button {
      .is-flat {
        .button-label {
          text-align: left;
        }
      }
    }
  }
}
